export default function({ title, message }) {
  return new Promise((resolve, reject) => {
    const result = confirm(`${title} \n ${message}`)
    resolve(result)
  })
}
